import { useDispatch } from "react-redux";
import { setBreadCrumbsData } from "../../../store/redux/breadCrumbsData";
import { useTranslation } from "react-i18next";
import CreateLocationForm from "../../../modules/locations/components/CreateLocationForm";

const CreateLocation = () => {
    const {t}=useTranslation()
    const dispatch=useDispatch()
    dispatch(setBreadCrumbsData({
        links: [{label: t("create_location"),path:"/locations/create-location"}],
		page_title: t("create_location"),
    }))

    return (
        <div>
            <CreateLocationForm />
        </div>
    );
}

export default CreateLocation;